"use client";
import React from "react";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button } from "@mui/material";

const accordions = [
  {
    title: "Open venster 2024",
    content: "Een oefening in leren voelen wat er te voelen valt.",
    link: "https://www.flipsnack.com/CABE9699E8C/2024-open-venster-58/full-view.html?p=6",
    linkText: "Open venster",
  },
  {
    title: "Open venster 2023",
    content:
      "SIPI leert patiënt zichzelf beter te kennen om crisissen te voorkomen.",
    link: "https://www.flipsnack.com/CABE9699E8C/2023-open-venster-57/full-view.html?p=10",
    linkText: "Open venster",
  },
  {
    title: "HLN",
    content:
      "Crisismoment in aantocht? Nieuwe app van psychiatrische kliniek verwittigt patiënten op tijd.",
    link: "https://www.hln.be/pittem/crisismoment-in-aantocht-nieuwe-app-van-psychiatrische-kliniek-verwittigt-patienten-op-tijd~a739cbb2/",
    linkText: "hln Sam Vanacker",
  },
  {
    title: "KW",
    content:
      "Kliniek Sint-Jozef in Pittem vertaalt vroegsignaleringsplan in app voor patiënten.",
    link: "https://kw.be/nieuws/samenleving/gezondheid/verzorging/kliniek-sint-jozef-in-pittem-vertaalt-vroegsignaleringsplan-in-app-voor-patienten/",
    linkText: "Krant van West-Vlaanderen",
  },
  {
    title: "Sint-Jozef Pittem",
    content:
      "Kliniek Sint-Jozef vertaalt vroegsignaleringsplan in handige app.",
    link: "https://www.sintjozefpittem.be/nieuws/kliniek-sint-jozef-vertaalt-vroegsignaleringsplan-handige-app",
    linkText: "Sint-Jozef Pittem",
  },
  {
    title: "Blue Health Innovation Rampup",
    content: `
Proficiat aan onze kersvers afgestudeerde deelnemers van Health RampUp.\n
\n
Afgelopen donderdag vond in dunden de finale jury pitch van ons coaching programma plaats. Na een intensief traject van zes maanden hebben zeven start-ups hun oplossing aan een jury gepitcht.\n
\n
En de jury was unamiem: \n
Zeven nieuwe start-ups zijn klaar om ons zorgysteem te verbeteren en te innoveren. Wij wensen hen dan ook heel veel succes met de uitbouw van hun start-up idee. 🍀🚀
`,
    link: "https://www.linkedin.com/posts/bhiccare_healthrampup-cohortx-healthcare-activity-7023599954816303104-CV4N?utm_source=share&utm_medium=member_desktop",
    linkText: "Tom Braekeleirs, CEO van BHI",
  },
  {
    title: 'Tweede plaats "The Next Generation Award" van Cybersec Europe​',
    content:
      "De solostudent van de KULAK ten slotte, kwam zijn startup eMindbrowser voorstellen. Het is een Android-app die zeer gevoelige data kan beschermen, zoals bijvoorbeeld online consultaties van psychologen en psychiaters met hun patiënten. Daarvoor wordt gebruikgemaakt van doorgedreven encryptie en intensieve hashing van wachtwoorden en logins, zowel aan de kant van de patiënt als aan de kant van de zorgverlener. Is er dan onverhoopt toch een datalek, dan is er nog geen man overboord omdat alle data versleuteld is. Ook bijvoorbeeld database operatoren of service providers die tussen de twee partijen in zitten, hebben geen toegang tot de data. Emindbrowser onderscheidt zich op die manier ook van veel andere, gelijkaardige initiatieven die echter veelal beroep doen op trusted third parties. Deze tool houdt alles binnen de eigen perimeters.",
    link: "https://www.computable.be/artikel/nieuws/startups/7353034/5440850/dit-zijn-de-winnaars-van-de-computable-awards-2022.html",
    linkText: "Computable.be Frederic Petitjean",
  },
];

const AccordionItem = (accordion) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>{accordion.title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>{accordion.content}</Typography>
        <Button href={accordion.link}>{accordion.linkText}</Button>
      </AccordionDetails>
    </Accordion>
  );
};

export default function termsofservice() {
  return (
    <>
      <Header noNavigation={true} />
      <div className="max-w-screen-xl mt-24 px-8 xl:px-16 mx-auto">
        <h1 className="text-2xl lg:text-3xl xl:text-4xl font-medium text-black-600 sm:pt-20 leading-normal">
          Onze missie
        </h1>
        <p className="my-2 text-black-500 pb-2">
          Eerst en vooral, we geloven in software als een tool, een hulpmiddel,
          en niet ter vervanging van huidige diensten. We willen een houvast
          bieden wanneer niemand er is, een plaats waar je kan denken en tot
          rust komen.
        </p>
        <h1 className="text-2xl lg:text-3xl xl:text-4xl font-medium text-black-600 leading-normal">
          Onze waarden
        </h1>
        <p className="my-2 pb-2 text-black-500">
          Privacy en welzijn zijn onze eerste prioriteiten. We voldoen aan de
          Europese GDPR wetgeving. Het platform maakt gebruik van AWS om
          veiligheid te waarborgen. Daar bovenop voorzien we encryptie die
          ervoor zorgt dat niemand behalve jij en jouw begeleider jouw data kan
          lezen. Onze succesvolle pentest in samenwerking met cybersecurity
          bedrijf Toreon bevestigt onze sterke beveiliging. Dankzij opleidingen
          zoals Blue Health Innovation Rampup en Leuven.inc zijn we op de hoogte
          van de laatste wetgevingen en voorzorgsmaatregelen.
        </p>
        <h1 className="text-2xl lg:text-3xl xl:text-4xl font-medium text-black-600 leading-normal pb-2">
          Media
        </h1>
        <div className="pb-32">
          {accordions.map((accordion) => (
            <AccordionItem {...accordion} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
